import get from 'lodash/get';
import cookie from 'cookie';
import { stringify } from 'qs';
import { getHostNameFromUrl } from './url';
import { getCitiesList, setCurrentCity } from '~/src/store/actions/city';
import { getDealersContact } from '~/src/store/actions/dealers';
import { getBecomeClientVariant, getMenuData } from '~/src/store/actions/menu';
import { loginByAccessToken } from '~/src/store/actions/auth';
import { ACCESS_TOKEN_COOKIE, BILLINGDOMAIN_COOKIE, MIGRATION_STATUS_COOKIE } from '~/src/constants';
import { isClientSide, isServerSide } from '~/src/helpers/ssr';

export async function initialProps(options) {
    const { store, req, res, query } = options;
    const { city } = store.getState();

    const headers = get(req, 'headers', '');
    const headerHost = headers.host;

    const hostname = isClientSide()
        ? getHostNameFromUrl(window.location)
        : get(req, 'hostname', getHostNameFromUrl(headerHost));

    const cityDomain = 'stelecom';

    if (city.currentCity.domain !== cityDomain) {
        await Promise.all([
            store.dispatch(getCitiesList()),
            store.dispatch(getDealersContact(cityDomain)),
        ]);

        store.dispatch(setCurrentCity(cityDomain));

        await Promise.all([
            store.dispatch(getMenuData(req, res)),
            store.dispatch(getBecomeClientVariant(req, res))
        ]);
    }

    if (isServerSide()) {
        const { pathname } = options;

        // Авторизация по токену или secret
        if (pathname !== '/api/auth') {
            const { token, secret } = req.query;

            if (token || secret) {
                const nextQuery = stringify(
                    {
                        token,
                        secret,
                        referrer: pathname,
                    },
                    { addQueryPrefix: true },
                );

                return res.writeHead(302, { Location: `/api/auth${nextQuery}` }).end();
            }
        }

        const accessToken = getCookieFromReq(req, ACCESS_TOKEN_COOKIE);
        const billingDomain = getCookieFromReq(req, BILLINGDOMAIN_COOKIE);
        const migrationStatus = getCookieFromReq(req, MIGRATION_STATUS_COOKIE);

        if (accessToken) {
            await store.dispatch(loginByAccessToken(accessToken, billingDomain, res, migrationStatus));
        }
    }

    return { hostname, headerHost, query, store };
}

/**
 * @param req
 * @param {string} cookieName
 * @return {undefined|string|null|number}
 */
export function getCookieFromReq(req, cookieName) {
    if (isClientSide() || !req || !req.headers || !req.headers.cookie) {
        return undefined;
    }

    const parsedCookie = cookie.parse(req.headers.cookie);

    return parsedCookie[cookieName];
}
